<template>
  <div class="page">
    <img class="welcome-img" style="width:40%;" src="~@/assets/logo.png" />

    <div class="span fs33 ac mt30 app-en" style="width:50%;margin: 200px auto;color: black;font-size: 30px">
      {{ msg }}
    </div>
    <img class="continue-btn" src="~@/assets/continue.png" @click="goto" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
  name: 'Error',
  data() {
    return {
      msg:'',
    }
  },
  computed: {
    ...mapState(['userInfo', 'lang', 'langMap'])
  },
  created() {
    let msg = this.$route.query.msg
    if(msg){
      this.msg = msg
    }
  },
  methods: {
    goto() {
      this.$router.push('land');
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('~@/assets/wel-bg.jpg') top center/cover repeat-y fixed;
  overflow: scroll;
}

.continue-btn {
  width: 45%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.welcome-img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

@media screen and (max-width: 360px) {
  .continue-btn {
    width: 45%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  .welcome-img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 75%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/error.vue